import { SUGGEST_TEMPLATE_FORM } from "common/constants";
import { app } from "js/namespaces";
import { FeatureType } from "../models/planPermissions";
import { getPricingPageUrl } from "./pricing";
import { trackActivity } from "./utilities";
import AppController from "js/core/AppController";

export const openSalesCalendar = (analytics = {}) => {
    const userIsBasicInWorkspace = app.user.features.isFeatureEnabled(FeatureType.UPGRADE, AppController.workspaceId);
    analytics.plan = userIsBasicInWorkspace ? "basic" : app.user.analyticsPersonalPlan;
    trackActivity("Sales", "ShowCalendar", null, null, analytics);
    window.open("https://calendly.com/beautifulteam/demo-call-with-beautiful-ai-upgrade-to-team", "_blank");
};

export const openPricingPage = (personalPlan = "pro", analytics = null) => {
    const userIsBasicInWorkspace = app.user.features.isFeatureEnabled(FeatureType.UPGRADE, AppController.workspaceId);
    const currentPlan = userIsBasicInWorkspace ? "basic" : personalPlan;

    if (analytics) {
        if (!analytics.cta) {
            throw new Error("analytics.cta is required");
        }

        trackActivity("Upgrade", "ShowPricingPage", null, null, analytics);
    }

    window.open(getPricingPageUrl(app && app.user.hasTakenTrial, app && app.user.has("hasTakenTeamTrial"), currentPlan), "_blank");
};

export const openTeamUpgrade = (analytics = {}) => {
    const userIsBasicInWorkspace = app.user.features.isFeatureEnabled(FeatureType.UPGRADE, AppController.workspaceId);
    analytics.plan = userIsBasicInWorkspace ? "basic" : app.user.analyticsPersonalPlan;
    trackActivity("Upgrade", "ShowTeamPricingPage", null, null, analytics);

    window.open("/team-upgrade", "_blank");
};

export const openSuggestTemplateForm = () => {
    window.open(SUGGEST_TEMPLATE_FORM, "_blank");
};
